export default __webpack_public_path__ + "static/media/36I-120857_-43995_0.f999481a.jpg";